import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./pages/home/Home"
import OurHistory from "./pages/our_history/OurHistory"
import Members from "./pages/members/Members"
import Navbar from './components/navbar/Navbar';
import NotableEvents from './pages/notable_events/Notable_Events';
import BuildHighlights from './pages/build_highlights/Build_Highlights';

function App() {


  return (
    
    <div className="App">

      {/* BrowserRouter creates an enviroment to navigate the page*/}
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route path="/history" element={<OurHistory/>}/>
          <Route path="/" element={<Home/>}/>
          <Route path="/Members" element={<Members/>}/>
          <Route path="/notable-events" element={<NotableEvents/>}/>
          <Route path="/build-highlights" element={<BuildHighlights/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
